// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.StaffHome {
  display: flex;
  flex-direction: column;
  margin: auto;
  width: 100%;
}
.StaffHome h1 {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  font-size: 3rem;
  color: #4d4d4d;
  text-align: center;
}
.StaffHome h1 span {
  color: #2c53a0;
}
.StaffHome .login {
  width: 50%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.StaffHome .login select {
  margin-right: 8px;
  box-shadow: inset 2px 2px 5px, #babecc, inset -5px -5px 10px #fff;
  width: 50%;
  box-sizing: border-box;
  transition: all 0.2s ease-in-out;
  appearance: none;
  -webkit-appearance: none;
  margin-bottom: 5%;
}
.StaffHome .login select:focus {
  box-shadow: inset 1px 1px 2px #babecc, inset -1px -1px 2px #fff;
}
.StaffHome .login input {
  margin-right: 8px;
  box-shadow: inset 2px 2px 5px, #babecc, inset -5px -5px 10px #fff;
  width: 50%;
  box-sizing: border-box;
  transition: all 0.2s ease-in-out;
  appearance: none;
  -webkit-appearance: none;
  margin-bottom: 5%;
}
.StaffHome .login input:focus {
  box-shadow: inset 1px 1px 2px #babecc, inset -1px -1px 2px #fff;
}
.StaffHome .login input,
.StaffHome .login select {
  border: 0;
  outline: 0;
  font-size: 1.2rem;
  border-radius: 320px;
  padding: 16px;
  background-color: #ebecf0;
  text-shadow: 1px 1px 0 #fff;
}
.StaffHome .login button {
  width: 30%;
  color: #fff;
  background-color: #2c53a0;
  text-shadow: none;
  font-weight: 600;
  padding: 20px;
  border-radius: 10px;
  cursor: pointer;
  border: none;
}
.StaffHome .login button:hover {
  background-color: #babecc;
  color: #2c53a0;
}
.StaffHome .columns {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  min-height: 60vh;
  width: 100%;
}
.StaffHome .columns .column {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.StaffHome .columns .column:nth-child(1) {
  margin-bottom: 2%;
}
.StaffHome .columns .column h2 {
  text-decoration: underline;
  color: #2c53a0;
  margin-bottom: 0;
  font-size: 2.5rem;
}
.StaffHome .columns .column .row {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 5%;
  width: 80%;
  margin: auto;
}
.StaffHome .columns .column .row .img {
  border-radius: 0.5rem;
  margin-top: 2%;
  padding-left: 1%;
  overflow: hidden;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  height: 120px;
  width: 250px;
  background-color: #fff;
}
.StaffHome .columns .column .row .img:hover {
  box-shadow: none;
}
.StaffHome .columns .column .row .img img {
  width: 80%;
  height: auto;
  margin: auto;
  align-self: center;
}
.StaffHome .columns .column .row .img span {
  position: relative;
  margin-left: 90%;
  z-index: 10;
  color: #2c53a0;
  font-weight: 800;
  border-radius: 50%;
  padding: 1%;
}
.StaffHome .columns .column .row .img p {
  text-transform: uppercase;
  color: #4d4d4d;
  position: absolute;
  margin: 8% 18%;
  width: 55%;
  font-weight: 800;
  font-size: 2rem;
}
.StaffHome .columns .column .row #img {
  border-radius: 0.5rem;
  margin-top: 2%;
  padding-left: 1%;
  overflow: hidden;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  height: 120px;
  width: 250px;
  background-color: #fff;
  position: relative;
}
.StaffHome .columns .column .row #img:hover {
  box-shadow: none;
}
.StaffHome .columns .column .row #img p {
  text-transform: uppercase;
  color: #4d4d4d;
  position: absolute;
  margin: 8% 18%;
  width: 55%;
  font-weight: 800;
  font-size: 2rem;
}
@media (max-width: 600px) {
  .StaffHome .columns .column .row #img {
    width: 80%;
    margin: auto;
    margin-bottom: 3%;
    width: 200px;
    height: 100px;
    padding: 0 1%;
  }
  .StaffHome .columns .column .row #img p {
    margin: 6% 15%;
  }
}
.StaffHome .columns .column .row .alert__labels {
  animation: backgroundanimate 2s infinite;
}
.StaffHome .repair__system {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 90%;
  margin: -2% auto 1% auto;
}
.StaffHome .repair__system .repair__form {
  background-color: #fff;
  border-radius: 1rem;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
  width: 40vw;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.StaffHome .repair__system .repair__form h6 {
  text-align: center;
  color: #4d4d4d;
  font-size: 1.2rem;
}
.StaffHome .repair__system .repair__form table {
  width: 95%;
  margin: auto;
  border-collapse: collapse;
  margin-top: 0;
  color: #4d4d4d;
}
.StaffHome .repair__system .repair__form table thead {
  background-color: #021859;
  color: #f2f2f2;
}
.StaffHome .repair__system .repair__form table tbody tr:nth-child(even) {
  background-color: #2c53a0;
  color: #fff;
}
.StaffHome .repair__system .repair__form .form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  color: #4d4d4d;
  margin-bottom: 2%;
}
.StaffHome .repair__system .repair__form .form label span {
  color: #be1a1a;
}
.StaffHome .repair__system .repair__form .form input {
  margin: 1% 0;
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
  height: 2rem;
}
.StaffHome .repair__system .repair__form .form select {
  width: 80%;
  margin: 1% 0;
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
  height: 2rem;
}
.StaffHome .repair__system .repair__form .form input[type=checkbox] {
  height: 1rem;
}
.StaffHome .repair__system .repair__form .form input[type=date], .StaffHome .repair__system .repair__form .form select {
  background-color: #fff;
}
@media (max-width: 600px) {
  .StaffHome .repair__system {
    flex-direction: column;
  }
  .StaffHome .repair__system .repair__form {
    width: 90vw;
    margin-bottom: 2%;
  }
  .StaffHome .repair__system .form {
    width: 90%;
    margin: auto;
  }
}
@media (min-width: 650px) and (max-width: 900px) {
  .StaffHome .repair__system .repair__form {
    width: 42vw;
    margin-bottom: 2%;
  }
  .StaffHome .repair__system .form {
    width: 90%;
    margin: auto;
  }
}

@media (max-width: 600px) {
  .StaffHome h1 {
    font-size: 1.5rem;
  }
  .StaffHome .login {
    width: 80%;
  }
  .StaffHome .login select,
  .StaffHome .login input {
    width: 100%;
    align-self: center;
  }
  .StaffHome .login button {
    width: 40%;
  }
  .StaffHome .login input {
    margin-left: 0.5%;
  }
  .StaffHome .columns {
    display: flex;
    flex-wrap: wrap;
  }
  .StaffHome .columns .column {
    width: 100%;
  }
  .StaffHome .columns .column h2 {
    font-size: 1.5rem;
    margin-bottom: 2%;
  }
  .StaffHome .columns .column .row {
    flex-wrap: wrap;
  }
  .StaffHome .columns .column .row .img {
    width: 80%;
    margin: auto;
    margin-bottom: 3%;
    width: 200px;
    height: 100px;
    padding: 0 1%;
  }
  .StaffHome .columns .column .row .img img {
    width: 150px;
    height: auto;
  }
  .StaffHome .columns .column .row .img p {
    margin: 6% 15%;
  }
}
@media (min-width: 601px) and (max-width: 900px) {
  .StaffHome .columns .row {
    flex-wrap: wrap;
  }
}
@keyframes backgroundanimate {
  from {
    background-color: #fff;
  }
  to {
    background-color: #F2A007;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/StoreZone/styles/storeZone.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAAA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AAEJ;AAAI;EACI,iCAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAER;AAAQ;EACI,cDlBA;ACoBZ;AAEI;EACI,UAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAAR;AAEQ;EACI,iBAAA;EACA,iEAAA;EACA,UAAA;EACA,sBAAA;EACA,gCAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;AAAZ;AAEY;EACI,+DAAA;AAAhB;AAIQ;EACI,iBAAA;EACA,iEAAA;EACA,UAAA;EACA,sBAAA;EACA,gCAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;AAFZ;AAIY;EACI,+DAAA;AAFhB;AAOQ;;EAEI,SAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,2BAAA;AALZ;AAQQ;EACI,UAAA;EACA,WAAA;EACA,yBD1EA;EC2EA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AANZ;AAQY;EACI,yBAnFJ;EAoFI,cDpFJ;AC8EZ;AAWI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AATR;AAUQ;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AARZ;AASY;EACI,iBAAA;AAPhB;AASY;EACI,0BAAA;EACA,cDzGJ;EC0GI,gBAAA;EACA,iBAAA;AAPhB;AASY;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;AAPhB;AAQgB;EAEI,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;AAPpB;AAQoB;EACI,gBAAA;AANxB;AAQoB;EACI,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AANxB;AAQoB;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,cD5IZ;EC6IY,gBAAA;EACA,kBAAA;EACA,WAAA;AANxB;AAQoB;EACI,yBAAA;EACA,cDhJZ;ECiJY,kBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AANxB;AASgB;EACI,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAPpB;AAQoB;EACI,gBAAA;AANxB;AAQoB;EACI,yBAAA;EACA,cDxKZ;ECyKY,kBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AANxB;AAQoB;EAvBJ;IAwBQ,UAAA;IACA,YAAA;IACA,iBAAA;IACA,YAAA;IACA,aAAA;IACA,aAAA;EALtB;EAMsB;IACI,cAAA;EAJ1B;AACF;AAOgB;EACI,wCAAA;AALpB;AAUI;EACI,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,UAAA;EACA,wBAAA;AARR;AASQ;EACI,sBAAA;EACA,mBAAA;EDhLR,0CAAA;ECkLQ,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AAPZ;AAQY;EACI,kBAAA;EACA,cDnNJ;ECoNI,iBAAA;AANhB;AAQY;EACI,UAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cD3NJ;ACqNZ;AAOgB;EACI,yBAAA;EACA,cAAA;AALpB;AASwB;EACI,yBDtOhB;ECuOgB,WAAA;AAP5B;AAYY;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,cD9OJ;EC+OI,iBAAA;AAVhB;AAYoB;EACI,cAAA;AAVxB;AAagB;EACI,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;AAXpB;AAagB;EACI,UAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;AAXpB;AAcgB;EACI,YAAA;AAZpB;AAcgB;EACI,sBAAA;AAZpB;AAgBQ;EA1EJ;IA2EQ,sBAAA;EAbV;EAcU;IACI,WAAA;IACA,iBAAA;EAZd;EAcU;IACI,UAAA;IACA,YAAA;EAZd;AACF;AAcQ;EACI;IACI,WAAA;IACA,iBAAA;EAZd;EAcU;IACI,UAAA;IACA,YAAA;EAZd;AACF;;AAiBA;EAEQ;IACI,iBAAA;EAfV;EAkBM;IACI,UAAA;EAhBV;EAkBU;;IAEI,WAAA;IACA,kBAAA;EAhBd;EAmBU;IACI,UAAA;EAjBd;EAoBU;IACI,iBAAA;EAlBd;EAuBM;IACI,aAAA;IACA,eAAA;EArBV;EAuBU;IACI,WAAA;EArBd;EAuBc;IACI,iBAAA;IACA,iBAAA;EArBlB;EAuBc;IACI,eAAA;EArBlB;EAsBkB;IACI,UAAA;IACA,YAAA;IACA,iBAAA;IACA,YAAA;IACA,aAAA;IACA,aAAA;EApBtB;EAqBsB;IACI,YAAA;IACA,YAAA;EAnB1B;EAsBsB;IACI,cAAA;EApB1B;AACF;AA8BA;EAGY;IACI,eAAA;EA9Bd;AACF;AAmCA;EACI;IACI,sBAAA;EAjCN;EAmCE;IACI,yBAAA;EAjCN;AACF","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","$loginGrey: #babecc;\n@import '../../variables.scss';\n\n\n.StaffHome {\n    display: flex;\n    flex-direction: column;\n    margin: auto;\n    width: 100%;\n\n    h1 {\n        font-family: 'Roboto', sans-serif;\n        text-transform: uppercase;\n        font-size: 3rem;\n        color: #4d4d4d;\n        text-align: center;\n\n        span {\n            color: $nitroDark;\n        }\n    }\n\n    .login {\n        width: 50%;\n        margin: auto;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        select {\n            margin-right: 8px;\n            box-shadow: inset 2px 2px 5px, #babecc, inset -5px -5px 10px #fff;\n            width: 50%;\n            box-sizing: border-box;\n            transition: all 0.2s ease-in-out;\n            appearance: none;\n            -webkit-appearance: none;\n            margin-bottom: 5%;\n\n            &:focus {\n                box-shadow: inset 1px 1px 2px $loginGrey, inset -1px -1px 2px #fff;\n            }\n        }\n\n        input {\n            margin-right: 8px;\n            box-shadow: inset 2px 2px 5px, $loginGrey, inset -5px -5px 10px #fff;\n            width: 50%;\n            box-sizing: border-box;\n            transition: all 0.2s ease-in-out;\n            appearance: none;\n            -webkit-appearance: none;\n            margin-bottom: 5%;\n\n            &:focus {\n                box-shadow: inset 1px 1px 2px $loginGrey, inset -1px -1px 2px #fff;\n            }\n\n        }\n\n        input,\n        select {\n            border: 0;\n            outline: 0;\n            font-size: 1.2rem;\n            border-radius: 320px;\n            padding: 16px;\n            background-color: #ebecf0;\n            text-shadow: 1px 1px 0 #fff;\n        }\n\n        button {\n            width: 30%;\n            color: #fff;\n            background-color: $nitroDark;\n            text-shadow: none;\n            font-weight: 600;\n            padding: 20px;\n            border-radius: 10px;\n            cursor: pointer;\n            border: none;\n\n            &:hover {\n                background-color: $loginGrey;\n                color: $nitroDark;\n            }\n        }\n    }\n\n    .columns {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        margin: auto;\n        min-height: 60vh;\n        width: 100%;\n        .column {\n            display: flex;\n            flex-direction: column;\n            width: 100%;\n            &:nth-child(1){\n                margin-bottom: 2%;\n            }\n            h2 {\n                text-decoration: underline;\n                color: $nitroDark;\n                margin-bottom: 0;\n                font-size: 2.5rem;\n            }\n            .row {\n                display: flex;\n                justify-content: space-evenly;\n                align-items: center;\n                margin-bottom: 5%;\n                width: 80%;\n                margin: auto;\n                .img {\n                    // border: 1px solid $nitroDark;\n                    border-radius: .5rem;\n                    margin-top: 2%;\n                    padding-left: 1%;\n                    overflow: hidden;\n                    box-shadow: 4px 2px 8px rgba(0, 0, 0, .2);\n                    cursor: pointer;\n                    height: 120px;\n                    width: 250px;\n                    background-color: #fff;\n                    &:hover {\n                        box-shadow: none;\n                    }\n                    img {\n                        width: 80%;\n                        height: auto;\n                        margin: auto;\n                        align-self: center;\n                    }\n                    span {\n                        position: relative;\n                        margin-left: 90%;\n                        z-index: 10;\n                        color: $nitroDark;\n                        font-weight: 800;\n                        border-radius: 50%;\n                        padding: 1%;\n                    }\n                    p{\n                        text-transform: uppercase;\n                        color: $fontColor;\n                        position: absolute;\n                        margin: 8% 18%;\n                        width: 55%;\n                        font-weight: 800;\n                        font-size: 2rem;\n                    }\n                }\n                #img {\n                    border-radius: .5rem;\n                    margin-top: 2%;\n                    padding-left: 1%;\n                    overflow: hidden;\n                    box-shadow: 4px 2px 8px rgba(0, 0, 0, .2);\n                    cursor: pointer;\n                    height: 120px;\n                    width: 250px;\n                    background-color: #fff;\n                    position: relative;\n                    &:hover {\n                        box-shadow: none;\n                    }\n                    p{\n                        text-transform: uppercase;\n                        color: $fontColor;\n                        position: absolute;\n                        margin: 8% 18%;\n                        width: 55%;\n                        font-weight: 800;\n                        font-size: 2rem;\n                    }\n                    @media(max-width: $mobile){\n                        width: 80%;\n                        margin: auto;\n                        margin-bottom: 3%;\n                        width: 200px;\n                        height: 100px;\n                        padding: 0 1%;\n                        p{\n                            margin: 6% 15%; \n                        }\n                    }\n                }\n                .alert__labels{\n                    animation: backgroundanimate 2s infinite;\n                }\n            }\n        }\n    }\n    .repair__system{\n        display: flex;\n        align-items: flex-start;\n        justify-content: space-between;\n        width: 90%;\n        margin: -2% auto 1% auto;\n        .repair__form{\n            background-color: #fff;\n            border-radius: 1rem;\n            @include shadow;\n            width: 40vw;\n            min-height: 60vh;\n            display: flex;\n            flex-direction: column;\n            align-items:center;\n            justify-content: flex-start;\n            h6{\n                text-align: center;\n                color: $fontColor;\n                font-size: 1.2rem;\n            }\n            table{\n                width: 95%;\n                margin: auto;\n                border-collapse: collapse;\n                margin-top: 0;\n                color: $fontColor;\n                thead{\n                    background-color: #021859;\n                    color: #f2f2f2;\n                }\n                tbody{\n                    tr{\n                        &:nth-child(even){\n                            background-color: $nitroDark;\n                            color:#fff;\n                        }\n                    }\n                }\n            }\n            .form{\n                display: flex;\n                flex-direction: column;\n                align-items: flex-start;\n                justify-content: flex-start;\n                color: $fontColor;\n                margin-bottom: 2%;\n                label{\n                    span{\n                        color: #be1a1a;\n                    }\n                }\n                input{\n                    margin: 1% 0;\n                    border: 1px solid $nitroDark;\n                    border-radius: .5rem;\n                    height: 2rem;\n                }\n                select{\n                    width: 80%;\n                    margin: 1% 0;\n                    border: 1px solid $nitroDark;\n                    border-radius: .5rem;\n                    height: 2rem;\n\n                }\n                input[type=checkbox]{\n                    height:1rem;\n                }\n                input[type=date], select{\n                    background-color: #fff;\n                }\n            }\n        }\n        @media (max-width: $mobile){\n            flex-direction: column;\n            .repair__form{\n                width: 90vw;\n                margin-bottom: 2%;\n            }\n            .form{\n                width: 90%;\n                margin: auto;\n            }\n        } \n        @media (min-width: 650px) and (max-width: $laptop){\n            .repair__form{\n                width: 42vw;\n                margin-bottom: 2%;\n            }\n            .form{\n                width: 90%;\n                margin: auto;\n            }\n        }  \n    }\n}\n\n@media(max-width: $mobile) {\n    .StaffHome {\n        h1 {\n            font-size: 1.5rem;\n        }\n\n        .login {\n            width: 80%;\n\n            select,\n            input {\n                width: 100%;\n                align-self: center;\n            }\n\n            button {\n                width: 40%;\n            }\n\n            input {\n                margin-left: .5%;\n            }\n\n        }\n\n        .columns {\n            display: flex;\n            flex-wrap: wrap;\n\n            .column {\n                width: 100%;\n\n                h2 {\n                    font-size: 1.5rem;\n                    margin-bottom: 2%;\n                }\n                .row{\n                    flex-wrap: wrap;\n                    .img {\n                        width: 80%;\n                        margin: auto;\n                        margin-bottom: 3%;\n                        width: 200px;\n                        height: 100px;\n                        padding: 0 1%;\n                        img {\n                            width: 150px;\n                            height: auto;\n                            // align-self: center;\n                        }\n                        p{\n                            margin: 6% 15%; \n                        }\n                    }\n    \n                }\n\n            }\n        }\n    }\n}\n\n@media(min-width:601px) and (max-width:$laptop){\n    .StaffHome{\n        .columns{\n            .row{\n                flex-wrap: wrap;\n            }\n        }\n    }\n}\n\n@keyframes backgroundanimate {\n    from {\n        background-color: #fff;\n    }\n    to {\n        background-color: #F2A007;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
